import { useBunja } from 'bunja/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { useOverlayItem } from '@flipster/overlay';
import { Modal } from '@flipster/react/design-system/modal';
import { createStepComponent } from '@flipster/react/misc/step/Steps';

import { EditProfileModel, editProfileActionBunja, editProfileBunja } from './bunja';
import { EditProfileForm } from './form';
import PublicAgreement from './public-agreement';
import { EditProfileModalSegmentView, editProfileModalSegmentBunja } from './segment';

const Steps = createStepComponent<EditProfileModel>();

// see below if you want to know all cases of this modal
// https://prextech.slack.com/archives/C087CLN6AKD/p1739432159557139
export const EditProfileModal = () => {
  const { isOpen, close, unmount } = useOverlayItem();
  const { steps, payloadAtom } = useBunja(editProfileBunja);
  const { trackEditProfileSaveClick } = useBunja(editProfileModalSegmentBunja);
  const current = useAtomValue(steps.currentStepAtom);
  const back = useSetAtom(steps.backAtom);
  const { saveProfile, mutateProfile } = useBunja(editProfileActionBunja);
  const payload = useAtomValue(payloadAtom);

  return (
    <>
      <EditProfileModalSegmentView />
      <Modal.Root isOpen={isOpen} onClose={current.step === 'form' ? close : back} onExit={unmount}>
        <Steps model={current}>
          <Steps.Step step='form'>
            {() => (
              <EditProfileForm
                onSubmit={() => {
                  saveProfile();
                  trackEditProfileSaveClick();
                }}
              />
            )}
          </Steps.Step>
          <Steps.Step step='public'>
            {({ secondaryLabel, onSecondary }) => (
              <PublicAgreement
                onPrimary={async () => {
                  try {
                    await mutateProfile(payload);
                  } catch {
                    // Do nothing
                  }
                }}
                onSecondary={onSecondary}
                secondaryLabel={secondaryLabel}
              />
            )}
          </Steps.Step>
        </Steps>
      </Modal.Root>
    </>
  );
};
